import {
  MdDashboard, MdLocalHospital, MdPerson, MdEventNote,
  MdPeople, MdNotifications, MdBarChart, MdSettings,
  MdWarning, MdAccountBalance, MdAddPhotoAlternate, MdCampaign, MdStar, MdInsights,
  MdGroup, MdMoreHoriz,
} from 'react-icons/md';

/** Set to true to restore Emergency / SOS alerts in the hospital dashboard UI */
export const EMERGENCY_UI_ENABLED = false;

/** Shared hospital dashboard navigation — used by Sidebar + MobileBottomNav */
export const HOSPITAL_NAV = [
  { path: '/dashboard',         icon: MdDashboard,     label: 'Dashboard',        roles: ['admin', 'staff', 'hospital'] },
  { path: '/emergency-alerts',  icon: MdWarning,       label: 'Emergency',        roles: ['admin', 'staff', 'hospital'], emergency: true, hidden: !EMERGENCY_UI_ENABLED },
  { path: '/doctors',           icon: MdPerson,        label: 'Doctors',          roles: ['admin', 'staff', 'hospital'] },
  { path: '/appointments',      icon: MdEventNote,     label: 'Appointments',     roles: ['admin', 'staff', 'hospital'] },
  { path: '/patients',          icon: MdPeople,        label: 'Patients',         roles: ['admin', 'staff', 'hospital'] },
  { path: '/notifications',     icon: MdNotifications, label: 'Notifications',    roles: ['admin', 'staff', 'hospital'] },
  { path: '/reviews',           icon: MdStar,          label: 'Reviews',          roles: ['admin', 'staff', 'hospital'] },
  { path: '/analytics',         icon: MdInsights,      label: 'Analytics',        roles: ['admin', 'staff', 'hospital'] },
  { path: '/reports',           icon: MdBarChart,      label: 'Reports',          roles: ['admin', 'staff', 'hospital'] },
  { path: '/settlements',       icon: MdAccountBalance, label: 'Settlements',     roles: ['admin', 'hospital'] },
  { path: '/posts',             icon: MdAddPhotoAlternate, label: 'Posts',        roles: ['admin', 'hospital'] },
  { path: '/submit-offer',      icon: MdCampaign,      label: 'Offers',           roles: ['admin', 'hospital'] },
  { path: '/staff',             icon: MdGroup,         label: 'Staff',            roles: ['admin', 'hospital'] },
  { path: '/settings',          icon: MdSettings,      label: 'Settings',         roles: ['admin', 'hospital'], ownerOnly: true },
];

export const HOSPITAL_NAV_SECTIONS = [
  { label: 'Overview', items: EMERGENCY_UI_ENABLED ? ['/dashboard', '/emergency-alerts'] : ['/dashboard'] },
  { label: 'Management', items: ['/doctors', '/appointments', '/patients'] },
  { label: 'Finance', items: ['/analytics', '/reports', '/settlements'] },
  { label: 'Engagement', items: ['/notifications', '/reviews', '/posts', '/submit-offer'] },
  { label: 'Settings', items: ['/staff', '/settings'] },
];

/** Primary tabs shown in mobile bottom bar */
export const MOBILE_BOTTOM_NAV = [
  { path: '/dashboard',    icon: MdDashboard,  label: 'Home',     roles: ['admin', 'staff', 'hospital'] },
  { path: '/appointments', icon: MdEventNote,  label: 'Bookings', roles: ['admin', 'staff', 'hospital'] },
  { path: '/patients',     icon: MdPeople,     label: 'Patients', roles: ['admin', 'staff', 'hospital'] },
  { path: '/doctors',      icon: MdPerson,     label: 'Doctors', roles: ['admin', 'staff', 'hospital'] },
  { path: '__menu__',      icon: MdMoreHoriz,  label: 'Menu' },
];

export function filterNavForUser(nav, currentUser) {
  const role = currentUser?.role || 'staff';
  const hospitalRole = currentUser?.hospitalRole || 'owner';
  return nav.filter(n => {
    if (n.hidden) return false;
    if (!n.roles) return true;
    return n.roles.includes(role) && (!n.ownerOnly || hospitalRole === 'owner');
  });
}
